import { Resources } from 'constants/resources';

import { useState } from 'react';

import { AxiosResponse } from 'axios';
import { sendLogo } from 'config/requests/methodLogos';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Box } from 'shared/mui/Box';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';

import { MethodLogosCreateForm } from './MethodLogosCreateForm';

type MethodLogosCreateFormValues = {
  file?: FileList;
  filePath: string;
  name: string;
};

export const MethodLogosCreate: React.FC = () => {
  const notify = useNotify();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<any>();
  const form = useForm({
    defaultValues: {
      name: '',
      filePath: '',
      file: undefined,
    },
  });

  const submitForm = async (data: MethodLogosCreateFormValues) => {
    if (data?.file?.[0]) {
      const formData = new FormData();
      formData.append('file', data.file[0]);
      formData.append('name', data.name);
      try {
        await sendLogo(formData);
        await queryClient.invalidateQueries({ queryKey: [Resources.MethodLogos] });
        notify('Логотип создан!', { type: 'info' });
        navigate(-1);
      } catch {
        (e: AxiosResponse) => setErrors(e?.data);
      }
    } else {
      notify('Загрузите логотип!', { type: 'error' });
    }
  };

  return (
    <CreatePage listName="Логотипы методов" title="Создание логотипа">
      <Box pt={3}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(submitForm)}>
            <MethodLogosCreateForm errors={errors} />
            <CardActionsButtons
              rightActionsSlot={[
                <CancelButton key="method-logos-cancel" linkType="back" variant="outlined" />,
                <SaveButton key="save-button" label="Загрузить" />,
              ]}
              sx={{ padding: '24px 0 0 0' }}
            />
          </form>
        </FormProvider>
      </Box>
    </CreatePage>
  );
};
